import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { InputMask } from 'primereact/inputmask';
import { Tree, TreeCheckboxSelectionKeys, TreeMultipleSelectionKeys } from 'primereact/tree';
import { useGlobalState } from '../../../components/globalState/GlobalStateProvider';
import { FilterWeb } from '../../../interface/FilterWeb';
import { Fieldset } from 'primereact/fieldset';
import { PickList } from 'primereact/picklist';
import { InputNumber } from 'primereact/inputnumber';
import { RadioButton } from 'primereact/radiobutton';
import { Divider } from 'primereact/divider';
import { Tooltip } from 'primereact/tooltip';
import getFiltroPermissao from '../../../service/getFiltroPermissao';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import DegustacaoIcon from './DegustacaoIcon';




export default function FiltroPF({
  onProcess,
  onClose,
  msgs
}: {
  onProcess: (filterWeb: FilterWeb, automotiva: boolean) => void
  onClose: () => void,
  msgs: any
}) {
  const { t } = useTranslation();
  const { state } = useGlobalState();
  const [cpf, setCpf] = useState<string>("");
  const [selectedKeys, setSelectedKeys] = useState<string | TreeMultipleSelectionKeys | TreeCheckboxSelectionKeys | null>(null);
  const [selectedOptionCheck] = useState<any[]>([]);
  const [targets, setTargets] = useState<any[]>([]);
  const [, setValorCartao] = useState<number | null | undefined>(null);
  const [, setCartao] = useState<number | null | undefined>(null);
  const [, setBin] = useState<number | null | undefined>(null);
  const [selectedFilter, setSelectedFilter] = useState<any>();
  const [opcionais, setOpcionais] = useState<any[]>([]);
  const [validDocument, setValidDocument] = useState<boolean>(false)
  const [filtros, setFiltros] = useState<any[]>([]);
  const [options, setOptions] = useState<any[]|undefined>(undefined);
  const [nome, setNome] = useState<string|null>(null);
  const [uf, setUf] = useState<string|null>(null);
  const [cidade, setCidade] = useState<string|null>(null);
  const [ddd, setDDD] = useState<string>("");
  const [telefone, setTelefone] = useState<string>("");

  const validCPF = (documento: string) => {
    if (verifyCPF(documento)) {
      setValidDocument(true);
      msgs.current?.clear();

    }
    else {
      setValidDocument(false);
      window.scrollTo(0, 0);
      msgs.current?.clear();
      msgs.current?.show([
        { sticky: false, life: 100000, severity: 'error', summary: 'Erro', detail: 'Documento inválido', closable: false }

      ]);
    }

  }

 const changeFilter = (value:any) => {
    getFiltroPermissao(value.key).then(async (data) => {
      await applyFiltros(options, data, value.key)
      await setFiltros(data);
      setSelectedKeys(null)
      value.filtros = data;
      setSelectedFilter(value);
      setOpcionais(createOptionsOpcionais(value))
    })
  }

  const verifyCPF = (strCPF: string) => {
    strCPF = strCPF.replaceAll('.', '').replace('-', '')
    let Soma;
    let Resto;
    Soma = 0;
    if (strCPF === "00000000000") return false;
    if (strCPF === "11111111111") return false;
    if (strCPF === "22222222222") return false;
    if (strCPF === "33333333333") return false;
    if (strCPF === "44444444444") return false;
    if (strCPF === "55555555555") return false;
    if (strCPF === "66666666666") return false;
    if (strCPF === "77777777777") return false;
    if (strCPF === "88888888888") return false;
    if (strCPF === "99999999999") return false;

    for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto === 10) || (Resto === 11)) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

    Soma = 0;
    for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto === 10) || (Resto === 11)) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(10, 11))) return false;
    return true;
  }

  const expandNode = (node: any, _expandedKeys: any) => {
    if (node.children && node.children.length) {
      _expandedKeys[node.key] = true;

      for (let child of node.children) {
        expandNode(child, _expandedKeys);
      }
    }
  };

  const buscarFiltro = (value:any) => {
  if(Object.getOwnPropertyNames(value).length > 0){
    const key = Object.getOwnPropertyNames(value)[0]
    getFiltroPermissao(key).then((data) => {
      applyFiltros(options, data, key)
    })
  }
  
}

const applyFiltros = (options: any, filtros:any, value:string) => {
  options.forEach((item:any) => {
    if(item.key === value){
      item.filtros = filtros;
    }
    else{
      if(item.children && item.children.length > 0){
        applyFiltros(item.children, filtros, value)
      }
    }
    
  })
}



  const createOptionsOpcionais = (opcao: any) => {
    const option: any[] = [];

    if (opcao.permissoes && opcao.permissoes.length > 0) {
      opcao.permissoes
        .sort((a: any, b: any) => {
          if (!a.ordenacao) {
            return 1;
          }

          if (!b.ordenacao) {
            return -1;
          }

          if (a.ordenacao > b.ordenacao) {
            return 1;
          }
          if (a.ordenacao < b.ordenacao) {
            return -1;
          }
          return 0;
        }).forEach((element: any) => {

          if (element.value === 'QUODPFINDICADORESNEGOCIO_PERFIL' ||
            element.value === 'QUODPFINDICADORESNEGOCIO_MERCADO' ||
            element.value === 'QUODPFINDICADORESNEGOCIO_GESTAO' ||
            element.value === 'QUODPFINDICADORESNEGOCIO_CENARIO' ||
            element.value === 'QUODPFINDICADORESNEGOCIO_PONTUALIDADE') {
            if (targets.filter((s) => s.value === element.value).length === 0) {
              targets.push({ value: element.value, target: [] })
            }
          }
          option.push({
            label: element.label, informativo: element.informativo, key: element.value, Collapse: true, pickList: targets.filter((s) => s.value === element.value).length !== 0 ? element.permissoes : undefined, children: element.permissoes && targets.filter((s) => s.value === element.value).length === 0 ? createPermissoesOpcionaisFilhos(element.permissoes.filter((f: {
              tipoConsulta: string;
            }) => f.tipoConsulta === 'PF' || f.tipoConsulta === 'PFPJ'), false) : []
          });

        });
      expandAll(option)
    }
    return option;
  }


  const createPermissoesOpcionaisFilhos = (permissoes: any[], first: boolean) => {
    const option: any[] = [];
    if (permissoes) {
      permissoes
        .sort((a: any, b: any) => {
          if (!a.ordenacao) {
            return 1;
          }

          if (!b.ordenacao) {
            return -1;
          }

          if (a.ordenacao > b.ordenacao) {
            return 1;
          }
          if (a.ordenacao < b.ordenacao) {
            return -1;
          }
          return 0;
        })
        .forEach((element: {
          children: any; label: string; informativo: string; value: string; permissoes: any[]
        }) => {
          option.push({
            label: element.label, informativo: element.informativo, first: first, key: element.value, Collapse: true, pickList: targets.filter((s) => s.value === element.value).length !== 0 ? element.permissoes : undefined, children: element.permissoes && targets.filter((s) => s.value === element.value).length === 0 ? createPermissoesOpcionaisFilhos(element.permissoes.filter((f: {
              tipoConsulta: string;
            }) => f.tipoConsulta === 'PF' || f.tipoConsulta === 'PFPJ'), false) : []
          });
        });
    }
    return option;
  }

  const createOptions = () => {
    const option: any[] = [];

    state.user.consultas.filter((f: {
      tipoConsulta: string;
    }) => f.tipoConsulta === 'PF' || f.tipoConsulta === 'PFPJ')
      .sort((a: any, b: any) => {
        if (!a.ordenacao) {
          return 1;
        }

        if (!b.ordenacao) {
          return -1;
        }

        if (a.ordenacao > b.ordenacao) {
          return 1;
        }
        if (a.ordenacao < b.ordenacao) {
          return -1;
        }
        return 0;
      })
      .forEach((element: any) => {
        const filhos = element.permissoes ? element.permissoes.filter((f: {
          tipoConsulta: string;
        }) => f.tipoConsulta === 'PF' || f.tipoConsulta === 'PFPJ') : [];
        if (filhos.length > 0) {
          option.push({ root: true, informativo: element.informativo, label: element.label, key: element.value, Collapse: true, children: createPermissoesFilhos(filhos, true) });
        }

      });
    expandAll(option)
    return option;
  }

  const createPermissoesFilhos = (permissoes: any[], first: boolean) => {
    const option: any[] = [];
    if (permissoes) {
      permissoes
        .sort((a: any, b: any) => {
          if (!a.ordenacao) {
            return 1;
          }

          if (!b.ordenacao) {
            return -1;
          }

          if (a.ordenacao > b.ordenacao) {
            return 1;
          }
          if (a.ordenacao < b.ordenacao) {
            return -1;
          }
          return 0;
        })
        .forEach((element: {
          children: any; label: string; value: string; informativo: string; permissoes: any[]
        }) => {
          if (element.value === 'QUODPFINDICADORESNEGOCIO_PERFIL' ||
            element.value === 'QUODPFINDICADORESNEGOCIO_MERCADO' ||
            element.value === 'QUODPFINDICADORESNEGOCIO_GESTAO' ||
            element.value === 'QUODPFINDICADORESNEGOCIO_CENARIO' ||
            element.value === 'QUODPFINDICADORESNEGOCIO_PONTUALIDADE') {
            if (targets.filter((s) => s.value === element.value).length === 0) {
              targets.push({ value: element.value, target: [] })
            }

          }
          option.push({ label: element.label, informativo: element.informativo, first: first, key: element.value, Collapse: true, pickList: targets.filter((s) => s.value === element.value).length !== 0 ? element.permissoes : undefined, children: [], permissoes: element.permissoes });
        });
    }
    return option;
  }

  const expandAll = (option: any) => {
    let _expandedKeys = {};

    for (let node of option) {
      expandNode(node, _expandedKeys);
    }

    return _expandedKeys;
  };

  const mensagemErroFiltro = (mensagem : string) => {
    window.scrollTo(0, 0);
    msgs.current?.clear();
      msgs.current?.show([
          { sticky: false, life: 100000, severity: 'error', summary: 'Erro', detail: mensagem, closable: false }
        
      ]);
  }

  const ufs = [
    { name: 'Selecione', code: null },
    { name: 'AC', code: 'AC' },
    { name: 'AL', code: 'AL' },
    { name: 'AP', code: 'AP' },
    { name: 'AM', code: 'AM' },
    { name: 'BA', code: 'BA' },
    { name: 'CE', code: 'CE' },
    { name: 'ES', code: 'ES' },
    { name: 'GO', code: 'GO' },
    { name: 'MA', code: 'MA' },
    { name: 'MT', code: 'MT' },
    { name: 'MS', code: 'MS' },
    { name: 'MG', code: 'MG' },
    { name: 'PA', code: 'PA' },
    { name: 'PB', code: 'PB' },
    { name: 'PR', code: 'PR' },
    { name: 'PE', code: 'PE' },
    { name: 'PI', code: 'PI' },
    { name: 'RJ', code: 'RJ' },
    { name: 'RN', code: 'RN' },
    { name: 'RS', code: 'RS' },
    { name: 'RO', code: 'RO' },
    { name: 'RR', code: 'RR' },
    { name: 'SC', code: 'SC' },
    { name: 'SP', code: 'SP' },
    { name: 'SE', code: 'SE' },
    { name: 'TO', code: 'TO' }
  ];

  const verifyObrigatorioMinimo = (filteWeb :FilterWeb, filtro:any) => {
    let retorno = true;
    if(filtros.length === 1){
      return false;
    }
    filtros.filter((s1:any) => s1.tipoFiltro !== filtro.tipoFiltro && s1.obrigatorioMinimo ).forEach((f:any) => {
      retorno = validFiltro(filteWeb, f);
      if(retorno){
        return true;
      }
    })
 
    if(retorno){
      return true;
    }
    else{
      return false;
    }
  }
 
  const validFiltro = (filteWeb :FilterWeb, filtro:any) => {
    
    if(filtro.tipoFiltro.includes("NOME") && filtro.obrigatorio && !filteWeb.nome){
      return false;
    }
    if(filtro.tipoFiltro.includes("UF") && filtro.obrigatorio && !filteWeb.uf){
      return false;
    }
    if(filtro.tipoFiltro.includes("CIDADE") && filtro.obrigatorio && !filteWeb.cidade){
      return false;
    }
    if(filtro.tipoFiltro.includes("TELEFONE") && filtro.obrigatorio && !filteWeb.telefone){
      return false;
    }
    if(filtro.tipoFiltro.includes("DDD") && filtro.obrigatorio && !filteWeb.ddd){
      return false;
    }
    return true;
  }

  const valid = (filteWeb :FilterWeb) => {
    if(filteWeb.consultas.length === 0){
       mensagemErroFiltro('Opções de consulta obrigatório')
       return false;
    }
    let retorno = true;
    filtros.forEach((filtro:any) => {
      if(!validFiltro(filteWeb, filtro)){
        if(!filtro.obrigatorioMinimo || !verifyObrigatorioMinimo(filteWeb, filtro)){
          mensagemErroFiltro(filtro.descricao + ' obrigatório');
          retorno = false;
          return false;
        }
      }
    })
 
 
    return retorno;
  }

  const processConsulta = () => {

    const opcoes: string[] = [];
    if (selectedFilter) {
      opcoes.push(selectedFilter.key);
    }
    if (selectedKeys && Object.getOwnPropertyNames(selectedKeys).length) {
      Object.getOwnPropertyNames(selectedKeys).map((item) => opcoes.push(item));
    }
    /* else{
      if(selectedFilter.permissoes && selectedFilter.permissoes.length > 0){
        window.scrollTo(0, 0);
        msgs.current?.clear();
          msgs.current?.show([
              { sticky: false, life: 100000, severity: 'error', summary: 'Erro', detail: 'Selecione pelo menos um opcional', closable: false }
            
          ]);
          return;
      }
    }*/

    selectedOptionCheck.map((item) => opcoes.push(item.value));
    const filteWeb: FilterWeb = {
      documento: cpf,
      consultas: opcoes,
      valor: null,
      arrojado: null,
      usual: null,
      conservador: null,
      nome: nome,
      uf: uf,
      cidade: cidade,
      ddd: ddd,
      telefone: telefone,
      indicadores: targets.filter((s: any) => opcoes.includes(s.value))
    };
    if(valid(filteWeb)){
      onProcess(filteWeb, !cpf);
    }
  }
  const onChange = (event: any, key: string) => {
    const targetsOut = [{ value: key, target: event.target }]
    targets.filter((s: any) => s.value !== key).map((item: any) => targetsOut.push(item));
    setTargets(targetsOut)
  };
  const pickItemTemplate = (item: any) => {
    return (
      <div className="flex flex-wrap p-2 align-items-center gap-3">
        <div className="flex-1 flex flex-column gap-2">
          <span className="font-bold">{item.label}</span>
        </div>
      </div>
    );
  };
  const nodeTemplateRadio = (node: any, options: { className: string | undefined; }) => {
    let label = <div className='flex-consulta align-items-center'><RadioButton inputId={node.key} name="filter" value={node} onChange={(e) => changeFilter(e.value)} checked={selectedFilter?.key === node.key} />{selectedFilter?.key === node.key ? (<div style={{ paddingLeft: '0.2rem', fontSize: '0.85rem' }}>{nodeTemplate(node)}</div>) : (<label htmlFor={node.key} style={{ marginLeft: '0.2rem', fontSize: '0.85rem' }}>{node.label}</label>)}{node.informativo && (<i data-pr-tooltip={node.informativo} data-pr-position="right" data-pr-at="right+5 top" style={{ paddingLeft: '0.5rem', color: '#183462', fontSize: '1.2rem' }} className="custom-target-icon pi pi-question-circle"></i>)}<DegustacaoIcon permissao={node.key} /></div>;
    if (node.children.length !== 0) {
      label = <b style={{ fontSize: '0.85rem' }}>{node.label}<DegustacaoIcon permissao={node.key} /></b>;
    }

    return label;
  }
  const isFilterRequired = (nodeFiltros: any[], tipoFiltro: string): boolean => {
    if (!nodeFiltros) return false;
    const filtro = nodeFiltros.find((f: any) => f.tipoFiltro === tipoFiltro);
    return filtro?.obrigatorio === true;
  };

  const validateAllRequiredFilters = (nodeFiltros: any[], updatedField?: string, updatedValue?: any) => {
    if (!nodeFiltros || nodeFiltros.length === 0) {
      setValidDocument(true);
      return;
    }

    const getValue = (field: string, currentValue: any) => {
      return updatedField === field ? updatedValue : currentValue;
    };

    let allFilled = true;
    nodeFiltros.forEach((filtro: any) => {
      if (filtro.obrigatorio) {
        if (filtro.tipoFiltro === 'NOME' && !getValue('nome', nome)) allFilled = false;
        if (filtro.tipoFiltro === 'UF' && !getValue('uf', uf)) allFilled = false;
        if (filtro.tipoFiltro === 'CIDADE' && !getValue('cidade', cidade)) allFilled = false;
        if (filtro.tipoFiltro === 'DDD' && !getValue('ddd', ddd)) allFilled = false;
        if (filtro.tipoFiltro === 'TELEFONE' && !getValue('telefone', telefone)) allFilled = false;
      }
    });

    setValidDocument(allFilled);
  };

  const nodeTemplate = (node: any) => {
    let label = <span>{node.label}<DegustacaoIcon permissao={node.key} /></span>;
    if (node.children.length !== 0 || node.first) {
      label = <b className={node.root ? 'root' : ''} onClick={(e) => { if (node.root) { e.stopPropagation() } }}>{node.label}<DegustacaoIcon permissao={node.key} /></b>;
    }
    let content: any = null;
    if (node.key.includes('QUODAUTENTICACARTAO') && ((selectedFilter && selectedFilter === 'QUODAUTENTICACARTAO') || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes('QUODAUTENTICACARTAO')))) {
       content = <>{content}
                  {content && <br/>}
       
          <div className="flex-auto">
            <label htmlFor="cartao" className="font-bold block mb-2 required">{t('cartao')}</label>
            <InputNumber inputId="cartao" onValueChange={(e) => setCartao(e.value)} useGrouping={false} size={4} maxLength={4} placeholder='Últimos 4 dígitos do cartão' />
          </div>
          <br></br>
          <div className="flex-auto">
            <label htmlFor="bin" className="font-bold block mb-2 required">{t('bin')}</label>
            <InputNumber inputId="bin" onValueChange={(e) => setBin(e.value)} useGrouping={false} size={9} maxLength={9} placeholder='Primeiros 6 a 9 dígitos do cartão' />
          </div>
          <br></br>
          <div className="flex-auto">
            <label htmlFor="currency" className="font-bold block mb-2">{t('valor')}</label>
            <InputNumber inputId="currency" onValueChange={(e) => setValorCartao(e.value)} mode="currency" currency="BRL" locale="pt-BR" />
          </div>
          <br></br>


      </>
    }

    if(((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1:any) => s1.tipoFiltro === 'NOME').length > 0){
      const nomeRequired = isFilterRequired(node.filtros, 'NOME');
      content = <>{content}
                {content && <br/>}
                <div className="flex-auto">
                  <label htmlFor="nome" className={`font-bold block mb-2 ${nomeRequired ? 'required' : ''}`}>{t('nome')}</label>
                    <InputText value={nome} onChange={(e) => {setNome(e.target.value); validateAllRequiredFilters(node.filtros, 'nome', e.target.value)}} 
                                      placeholder="Digite Nome" />
                </div>
      </>
    }
    if(((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1:any) => s1.tipoFiltro === 'UF').length > 0){
      const ufRequired = isFilterRequired(node.filtros, 'UF');
      content = <>{content}
                {content && <br/>}
                <div className="flex-auto">
                  <label htmlFor="uf" className={`font-bold block mb-2 ${ufRequired ? 'required' : ''}`}>{t('uf')}</label>
                   <Dropdown value={uf} onChange={(e) => {setUf(e.value); validateAllRequiredFilters(node.filtros, 'uf', e.value)}} options={ufs} optionLabel="name" 
                                      placeholder="Selecione o Estado" optionValue='code' className="w-full md:w-14rem" />
                </div>
      </>
    }
    if(((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1:any) => s1.tipoFiltro === 'CIDADE').length > 0){
      const cidadeRequired = isFilterRequired(node.filtros, 'CIDADE');
      content = <>{content}
                {content && <br/>}
                <div className="flex-auto">
                  <label htmlFor="cidade" className={`font-bold block mb-2 ${cidadeRequired ? 'required' : ''}`}>{t('cidade')}</label>
                    <InputText value={cidade} onChange={(e) => {setCidade(e.target.value); validateAllRequiredFilters(node.filtros, 'cidade', e.target.value)}} 
                                      placeholder="Digite Cidade" />
                </div>
      </>
    }

    if(((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1:any) => s1.tipoFiltro === 'DDD').length > 0){
      const dddRequired = isFilterRequired(node.filtros, 'DDD');
      content = <>{content}
                {content && <br/>}
                <div className="flex-auto">
                  <label htmlFor="ddd" className={`font-bold block mb-2 ${dddRequired ? 'required' : ''}`}>{t('ddd')}</label>
                    <InputText value={ddd} onChange={(e) => {setDDD(e.target.value); validateAllRequiredFilters(node.filtros, 'ddd', e.target.value)}} 
                                      placeholder="Digite DDD" />
                </div>
      </>
    }

    if(((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1:any) => s1.tipoFiltro === 'TELEFONE').length > 0){
      const telefoneRequired = isFilterRequired(node.filtros, 'TELEFONE');
      content = <>{content}
                {content && <br/>}
                <div className="flex-auto">
                  <label htmlFor="telefone" className={`font-bold block mb-2 ${telefoneRequired ? 'required' : ''}`}>{t('telefone')}</label>
                    <InputText value={telefone} onChange={(e) => {setTelefone(e.target.value); validateAllRequiredFilters(node.filtros, 'telefone', e.target.value)}} 
                                      placeholder="Digite Telefone" />
                </div>
      </>
    }

    if ((node.pickList && selectedKeys && ((selectedFilter && selectedFilter.key === node.key) || (Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))))) {

     content = <>{content}
                {content && <br/>}
        
          <PickList dataKey="value" onChange={(e) => { onChange(e, node.key) }} itemTemplate={pickItemTemplate} showSourceControls={false} showTargetControls={false} source={node.pickList.filter((s: any) => { return targets.filter((s: any) => s.value === node.key)[0].target.filter((s2: any) => s.value === s2.value).length === 0 })} target={targets.filter((s: any) => s.value === node.key)[0].target} filter filterBy="label"
            sourceHeader="Indicadores" targetHeader="Selecionados" sourceStyle={{ height: '24rem' }} targetStyle={{ height: '24rem' }}
            sourceFilterPlaceholder="Busca" targetFilterPlaceholder="Busca" />
      </>
    }

    if(content) {
      return <Fieldset onClick={(e)=> e.stopPropagation()} legend={node.label}>{content}</Fieldset>
    }

    return label
  }


  useEffect(()=> {
    setOptions(createOptions())  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  return (<>
    <Panel header={t('consultaPF')}>
      <Tooltip target=".custom-target-icon" />
      <Tooltip target=".degustacao-icon" />
      <div className=" p-fluid flex flex-wrap gap-3">
        <div className="flex-auto">
          <label htmlFor="cpf" className="font-bold block mb-2 required">CPF</label>
          <InputMask id="cpf" value='cpf' onBlur={(e) => { setCpf(e.target.value); validCPF(e.target.value) }} mask="999.999.999-99" placeholder="999.999.999-99" required></InputMask>
        </div>
        <br></br>
        <div className=" p-fluid flex flex-wrap gap-3">
          <Tree filter filterMode="lenient" nodeTemplate={nodeTemplateRadio} expandIcon={undefined} collapseIcon={undefined} expandedKeys = {expandAll(createOptions())} value={options} selectionKeys={selectedKeys} onSelectionChange={(e) => {setSelectedKeys(e.value);  }} style={{border:'none', marginLeft:'-2.0rem', background:'transparent'}}  />
        </div>
        {opcionais && opcionais.length > 0 && (
          <div className=" p-fluid flex flex-wrap gap-3">
            <Divider className="automotiva" align="left">
              <div className="flex-score justify-content-between justify-content-center">
                <span
                  className="p-tag"
                  style={{
                    position: "relative",
                    backgroundColor: "#183462",
                    fontSize: "1.1rem",
                    height: "2rem",

                  }}
                >
                  Opcionais
                </span>
              </div>
            </Divider>
            <Tree nodeTemplate={nodeTemplate} expandIcon={undefined} collapseIcon={undefined} expandedKeys={expandAll(opcionais)} value={opcionais} selectionMode='checkbox' selectionKeys={selectedKeys} onSelectionChange={(e) => {buscarFiltro(e.value); setSelectedKeys(e.value); }} style={{ border: 'none', marginLeft: '-2.0rem', background: 'transparent' }} />
          </div>
        )}


      </div>
     

    </Panel>
    {/* Footer sempre visível */}
      <div style={{
        position: 'sticky',
        bottom: 0,
        backgroundColor: '#f9fafb',
        borderTop: '1px solid #ddd',
        padding: '1rem',
        display: 'flex',
        justifyContent: 'flex-end',
        boxShadow: '0 -2px 4px rgba(0,0,0,0.1)',
        marginTop: 'auto'
      }}>
        <Button 
          disabled={!validDocument} 
          style={{backgroundColor:'#183462'}} 
          label="Consultar"  
          onClick={processConsulta} 
        />
      </div>

  </>
  )
}

